import { gql } from 'glimmer-apollo';

export const NEWS_INDEX_QUERY = gql`
  query NewsIndexQuery($page: Int = 1, $limit: Int = 10) {
    articles: gameArticlesPaginated(page: $page, limit: $limit) {
      items {
        title
        slug
        shortDescription
        publishedDate
        body
        coverImage {
          url
        }
        author {
          name
          avatar {
            url
          }
        }
      }
      totalCount
      page
      limit
      hasNextPage
      hasPreviousPage
    }
    popularArticles: gameArticles(limit: 3) {
      __typename
      title
      slug
      coverImage {
        url
      }
      author {
        name
        avatar {
          url
        }
      }
      publishedDate
    }
  }
`;
